import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=32c133ae&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=32c133ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c133ae",
  null
  
)

export default component.exports